import {useState} from 'react'

import PropTypes from 'prop-types'

import {MoleculeAccordionItem} from '@s-ui/react-molecule-accordion'

export const AccordionListItem = ({label, children, isExpanded: propIsExpended = true}) => {
  const [isExpanded, setIsExpanded] = useState(propIsExpended)
  const toggleExpanded = () => setIsExpanded(!isExpanded)
  return (
    <MoleculeAccordionItem as="div" headerAs="h3" isExpanded={isExpanded} label={label} onClick={toggleExpanded}>
      {children}
    </MoleculeAccordionItem>
  )
}

AccordionListItem.propTypes = {
  children: PropTypes.object,
  isExpanded: PropTypes.bool,
  label: PropTypes.object
}
